// Vite-time environment variables. Only `VITE_*` prefixed vars are exposed.
//
// API_URL defaults to the local dev API (apps/api on port 8080).
// Auth0 settings are required for sign-in; until provisioned, set
// VITE_AUTH0_DEV_BYPASS=1 to skip the Auth0 provider and use a synthetic
// dev user (works against the API's DEV_JWT_SECRET).

export const env = {
  API_URL: import.meta.env.VITE_API_URL ?? 'http://localhost:8080',
  AUTH0_DOMAIN: import.meta.env.VITE_AUTH0_DOMAIN as string | undefined,
  AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID as string | undefined,
  AUTH0_AUDIENCE: import.meta.env.VITE_AUTH0_AUDIENCE as string | undefined,
  AUTH0_DEV_BYPASS: import.meta.env.VITE_AUTH0_DEV_BYPASS === '1',
  DEV_JWT: import.meta.env.VITE_DEV_JWT as string | undefined,
} as const;

export function hasAuth0(): boolean {
  return Boolean(env.AUTH0_DOMAIN && env.AUTH0_CLIENT_ID);
}
